module.exports = __webpack_public_path__ + "static/img/Qi_YU.eb18f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Qi_YU.png
// module id = T2Ms
// module chunks = 1